import {getUrlParams} from '../../utils';
import {isBaiduMap, getComVersion} from '../../utils';

export default {
    namespaced: true,

    state: {
        // 当前页面的url参数
        urlParams: {},
        abtest: '',
        // 笔记来源
        source: '',
        // url上的unqiue_id
        firstUnique_id: '',
        // url上的uid
        uid: '',
        // 笔记数据类型，笔记/评论转笔记
        dataType: 'feed',
        // 是否只显示单篇笔记
        showSingleNote: false,
        wxShareUid: '', // 分享poi的uid
        pointPosition: {
            loc_x: '',
            loc_y: ''// lat
        },
        // openapi点击跳转时间戳
        jump_time_stamp: 0,
        isShare: '', // 是否分享
        isPreloader: false, // 是否是webview预加载
        isHiddeNav: false, // 详情页是否隐藏导航
        isFeedAnimation: false, // 详情页是否有feed列表翻转动画
        comVersion: '', // 组件包版本
        isTaskOperate: false // 是否为冲刺打卡运营活动
    },

    getters: {
        urlParams: state => state.urlParams,
        abtest: state => state.abtest,
        source: state => state.source,
        firstUnique_id: state => state.firstUnique_id,
        uid: state => state.uid,
        dataType: state => state.dataType,
        showSingleNote: state => state.showSingleNote,
        wxShareUid: state => state.wxShareUid,
        pointPosition: state => state.pointPosition,
        jump_time_stamp: state => state.jump_time_stamp,
        isShare: state => state.isShare,
        isPreloader: state => state.isPreloader,
        isHiddeNav: state => state.isHiddeNav,
        isFeedAnimation: state => state.isFeedAnimation,
        comVersion: state => state.comVersion,
        isTaskOperate: state => state.isTaskOperate
    },

    mutations: {
        setUrlParams(state, params) {
            state.urlParams = params;
            state.abtest = params.abtest && decodeURIComponent(params.abtest) || '';
            state.source = params.source || '';
            state.firstUnique_id = params.unique_id || params.uniqkey || '';
            state.uid = params.uid || '';
            state.dataType = params.reqType || 'feed';
            state.isHiddeNav = params.hiddenNav === '1';
            state.showSingleNote = params.from === 'post_detail_article';
            state.wxShareUid = params.share_poi_uid || params.uid;
            state.jump_time_stamp = Number(params.jump_time_stamp) || 0;
            state.isShare = params.isShare;
            state.pointPosition.loc_x = params.poi_x;
            state.pointPosition.loc_y = params.poi_y;
            state.isPreloader = Number(params.is_preloader) === 1;
            state.isFeedAnimation = Number(params.feed_animation) === 1;
            state.comVersion = params.comVersion || getComVersion() || '';
            state.isTaskOperate = params.xnryy === 'CCDK' && isBaiduMap();
        },
        setIsFeedAnimation(state, isFeedAnimation) {
            state.isFeedAnimation = isFeedAnimation;
        },
        setFirstUnique_id(state, unique_id) {
            state.firstUnique_id = unique_id;
        },
        setDataType(state, dataType) {
            state.dataType = dataType;
        },
        setUid(state, uid) {
            state.uid = uid;
        },
        setWxShareUid(state, wxShareUid) {
            state.wxShareUid = wxShareUid;
        },
        setPointPosition(state, pointPosition) {
            state.pointPosition = pointPosition;
        },
        setHiddeNav(state, isHiddeNav) {
            state.isHiddeNav = isHiddeNav;
        }
    },

    actions: {
        fetchUrlParams({commit}) {
            const params = getUrlParams(window.location.href);

            if (Object.keys(params).length > 0) { // 确保不是空对象
                commit('setUrlParams', params);
            }
        }
    }
};